import React from "react";
/* Bootstrap Components */
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Carrousel from "react-multi-carousel";
import {
  StyledWrapperSpeakers,
  StyleUlCredits,
  StyledNewsletterContact,
  StyledScroll,
} from "./styled";
import "react-multi-carousel/lib/styles.css";
import Modal from "react-modal";
import { FaRegWindowClose } from "react-icons/fa";
const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1440 },
    items: 5,
    paritialVisibilityGutter: 60,
    slidesToSlide: 5,
  },
  desktop: {
    breakpoint: { max: 1439, min: 1024 },
    items: 2,
    paritialVisibilityGutter: 60,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    paritialVisibilityGutter: 50,
    slidesToSlide: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30,
  },
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const Speakers = (props, { deviceType }) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <Row id="speakers">
        <StyledWrapperSpeakers className="d-none d-lg-block">
          <Row>
            <Col xs={12} sm={12} md={4} lg={3} xl="2">
              <h1>Speakers</h1>
              <hr />
            </Col>
          </Row>
          <Row style={{ marginTop: "60px" }}>
            <Col lg="12">
              <Carrousel
                deviceType={deviceType}
                itemClass="image-item"
                responsive={responsive}
                showDots={true}
                swipeable={true}
                draggable={true}
                arrows={false}
              >
                {props.data?.map((el) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={el.url_img}
                      class="rounded-circle mx-auto"
                      style={{ width: "180px" }}
                      alt="perfiles"
                    />
                    <h3
                      style={{
                        textAlign: "center",
                        marginTop: "43px",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {el.nombre}
                    </h3>
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "20px",
                        marginBottom: "120px",
                        padding: "0 24px",
                        fontSize: "12px",
                      }}
                    >
                      {el.perfil_en}
                    </p>
                  </div>
                ))}
              </Carrousel>
            </Col>
          </Row>
        </StyledWrapperSpeakers>
      </Row>
      <Row className="d-block d-lg-none" id="speakers">
        <StyledNewsletterContact>
          <p
            style={{
              marginBottom: "0px",
              background: "#E63457",
              textAlign: "center",
              padding: "10px",
              borderRadius: "10px",
              color: "white",
            }}
          >
            <a onClick={openModal}>
              Attendees <br />
            </a>
          </p>
        </StyledNewsletterContact>
      </Row>
      <Row>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <Row>
            <Container>
              <Col lg={12} className="mx-auto">
                <Row>
                  <Col style={{ textAlign: "right" }}>
                    <FaRegWindowClose
                      onClick={closeModal}
                      style={{
                        color: "#354052",
                        fontSize: "20px",
                        marginRight: "5px",
                        verticalAlign: "sub",
                        cursor: "pointer",
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col
                    style={{
                      textAlign: "center",
                      marginBottom: "20px",
                      fontWeight: "bold",
                      color: "#dc4157",
                    }}
                  >
                    Attendees
                  </Col>
                </Row>
                <Row>
                  <StyledScroll
                    lg={12}
                    className="mx-auto"
                    style={{
                      height: "500px",
                      overflowY: "auto",
                      textalign: "justify",
                    }}
                  >
                    <Row>
                      <Col lg={12}>
                        {props.data?.map((el) => (
                          <>
                            <div
                              style={{
                                textAlign: "center",
                                marginBottom: "40px",
                              }}
                            >
                              <img
                                src={el.url_img}
                                class="rounded-circle mx-auto"
                                style={{ width: "99px" }}
                                alt="perfiles"
                              />
                            </div>

                            <p
                              style={{
                                lineHeight: "12px",
                                textAlign: "left",
                                marginBottom: "15px",
                                fontWeight: "bold",
                                marginTop: "2px",
                              }}
                            >
                              {el.nombre}
                            </p>
                            <p
                              style={{
                                lineHeight: "22px",
                                textAlign: "left",
                                marginBottom: "15px",
                              }}
                            >
                              {el.perfil_en}
                            </p>
                          </>
                        ))}
                      </Col>
                    </Row>
                  </StyledScroll>
                </Row>
              </Col>
            </Container>
          </Row>
        </Modal>
      </Row>
    </>
  );
};

export default Speakers;
